import { container } from "tsyringe";
import "reflect-metadata";
import { BookInWebSocket } from "./bookInWebSocket";
import { BookInSseSocket } from "./bookInSseSocket";
import { Logger } from "../commons/Log/Logger";
export const DependencyInjectorExternalInfrastructure = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const urlTransport = urlParams.get("transport");
    if (urlTransport === "sse" || urlTransport === "ws") {
        sessionStorage.setItem("transport", urlTransport);
    }
    let transport = sessionStorage.getItem("transport");
    if (transport !== "sse" && transport !== "ws") {
        transport = "ws";
        sessionStorage.setItem("transport", transport);
    }
    const instance = transport === "ws"
        ? BookInWebSocket.getInstance()
        : BookInSseSocket.getInstance();
    container.registerInstance("IEventBusSocket", instance);
    container.registerInstance('ILogger', new Logger());
};
export default DependencyInjectorExternalInfrastructure;
